import { render, staticRenderFns } from "./stayUploadPhotoWarehouse.vue?vue&type=template&id=387a5524&scoped=true&"
import script from "./stayUploadPhotoWarehouse.vue?vue&type=script&lang=js&"
export * from "./stayUploadPhotoWarehouse.vue?vue&type=script&lang=js&"
import style0 from "./stayUploadPhotoWarehouse.vue?vue&type=style&index=0&id=387a5524&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "387a5524",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('387a5524')) {
      api.createRecord('387a5524', component.options)
    } else {
      api.reload('387a5524', component.options)
    }
    module.hot.accept("./stayUploadPhotoWarehouse.vue?vue&type=template&id=387a5524&scoped=true&", function () {
      api.rerender('387a5524', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/AirExport/components/stayUploadPhotoList/stayUploadPhotoWarehouse.vue"
export default component.exports